import { QUESTION_FLOWS } from '@aysar/contracts';

import { type FieldDef } from '@/shared/components/dynamic-form/types/dynamic-form.types';

/** Translates a key, with interpolation. The caller's `t`. */
export type Translate = (key: string, params?: Record<string, unknown>) => string;

/**
 * The section form.
 *
 * `key` and `flow` are **locked after creation**, mirroring the update contract
 * which omits both: the key addresses the section and the flow decides which form
 * it belongs to, and moving either would relocate every question under it. The
 * fields stay on screen, disabled, rather than vanishing — an edit form that shows
 * fewer fields than the create form makes staff wonder what they lost.
 */
export function buildSectionFields(t: Translate, isEditing: boolean): FieldDef[] {
  return [
    {
      name: 'key',
      kind: 'slug',
      label: t('sections.form.key'),
      description: t('sections.form.keyHint'),
      sourceName: 'title',
      separator: '_',
      maxLength: 64,
      isRequired: true,
      isDisabled: isEditing,
      isLockedAfterCreate: true,
    },
    {
      name: 'flow',
      kind: 'select',
      label: t('sections.form.flow'),
      description: t('sections.form.flowHint'),
      isRequired: true,
      isDisabled: isEditing,
      options: QUESTION_FLOWS.map((flow) => ({ value: flow, label: t(`flow.${flow}`) })),
    },
    {
      name: 'title',
      kind: 'text',
      label: t('sections.form.sectionTitle'),
      isTranslatable: true,
      isRequired: true,
    },
    {
      name: 'description',
      kind: 'textarea',
      label: t('sections.form.description'),
      isTranslatable: true,
      colSpan: 'full',
    },
    { name: 'isActive', kind: 'switch', label: t('sections.form.isActive') },
  ];
}
